import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiFileText, FiHeart, FiCheckCircle, FiMessageSquare } = FiIcons;

const journeySteps = [
  { 
    id: 1, 
    title: 'Initial Consultation', 
    date: '2024-07-20', 
    status: 'completed', 
    icon: FiCalendar,
    details: 'Initial assessment and discussion of treatment options.'
  },
  { 
    id: 2, 
    title: 'Treatment Plan Agreement', 
    date: '2024-07-21', 
    status: 'completed', 
    icon: FiFileText,
    details: 'Patient and provider agreed on the proposed treatment plan.'
  },
  { 
    id: 3, 
    title: 'Pre-Op Assessment', 
    date: '2024-07-25', 
    status: 'active', 
    icon: FiHeart,
    details: 'Final checks and preparations before the procedure.'
  },
  { 
    id: 4, 
    title: 'Procedure', 
    date: '2024-08-01', 
    status: 'upcoming', 
    icon: FiCheckCircle,
    details: 'Scheduled date for the dental implant surgery.'
  },
  { 
    id: 5, 
    title: 'Post-Op Follow-up', 
    date: '2024-08-15', 
    status: 'upcoming', 
    icon: FiMessageSquare,
    details: 'Check-up to monitor healing and progress.'
  },
];

const PatientJourneyTab = ({ patientName }) => {
  const getStatusStyles = (status) => {
    switch (status) {
      case 'completed':
        return {
          iconBg: 'bg-green-500',
          lineBg: 'bg-green-500',
          text: 'text-gray-500'
        };
      case 'active':
        return {
          iconBg: 'bg-brand-primary',
          lineBg: 'bg-brand-primary',
          text: 'text-brand-primary'
        };
      case 'upcoming':
      default:
        return {
          iconBg: 'bg-gray-300',
          lineBg: 'bg-gray-300',
          text: 'text-gray-400'
        };
    }
  };

  return (
    <div>
      <h3 className="text-xl font-bold text-gray-800 mb-6">Patient Journey: {patientName}</h3>
      <div className="relative">
        <div className="absolute left-5 top-0 h-full w-0.5 bg-gray-200" aria-hidden="true"></div>

        <ul className="space-y-8">
          {journeySteps.map((step, index) => {
            const { iconBg, lineBg, text } = getStatusStyles(step.status);
            const isCompletedOrActive = step.status === 'completed' || step.status === 'active';
            
            return (
              <motion.li
                key={step.id}
                className="relative flex items-start"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                {isCompletedOrActive && (
                  <div className={`absolute left-5 top-5 h-full w-0.5 ${lineBg}`} />
                )}
                
                <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full z-10"
                     style={{ backgroundColor: iconBg.replace('bg-', '').split('-').reduce((acc, curr) => {
                       if (curr === 'green') return '#10b981';
                       if (curr === 'gray') return '#d1d5db';
                       return '#3b82f6';
                     }, '') }}>
                  <SafeIcon icon={step.icon} className="w-5 h-5 text-white" />
                </div>
                
                <div className="ml-6">
                  <p className={`font-bold text-lg ${step.status === 'active' ? 'text-brand-primary' : 'text-gray-800'}`}>
                    {step.title}
                  </p>
                  <p className={`text-sm font-medium ${text}`}>
                    {step.date}
                  </p>
                  <p className="mt-2 text-sm text-gray-600">
                    {step.details}
                  </p>
                </div>
              </motion.li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PatientJourneyTab;